export const LANGUAGES = ['en', 'id']

export const TRANSLATED_LANGUAGES = [
    { label: 'english', value: 'en' },
    { label: 'bahasa indonesia', value: 'id' }
]

export const SALESFORCE_LANGUAGES = {
    en: 'English',
    id: 'Bahasa'
}

export const MOMENT_LANGUAGES = {
    en: 'en',
    id: 'id'
}

export const MOMENT_LOCALE_WEEKDAYS = {
    en: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    id: 'M_S_S_R_K_J_S'.split('_')
}

export const MOMENT_LOCALE_MONTHS = {
    en: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    id: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_')
}

export const API_LANGUAGES = {
    en: 'en',
    id: 'id'
}
